// Third Party Lib

// Config
import { APP_CONFIG } from "../../config";

// Services
import { AWS } from "../../services/cloud";

const { AWS_URI } = APP_CONFIG;

const { S3GetObject } = AWS;


export const getDriverTemplateXLSXFromS3 = () =>
  S3GetObject(AWS_URI.s3.asset.bucket, AWS_URI.s3.asset.key.driverbulk)
    .then((data) => new Response(data.Body).blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "Driver_Bulk_Upload_Template.xlsx";

      link.click();

      window.URL.revokeObjectURL(blobUrl);
    });

export const getVehicleTemplateXLSXFromS3 = () =>
  S3GetObject(AWS_URI.s3.asset.bucket, AWS_URI.s3.asset.key.vehiclebulk)
    .then((data) => new Response(data.Body).blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "Vehicle_Bulk_Upload_Template.xlsx";

      link.click();

      window.URL.revokeObjectURL(blobUrl);
    });
